var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "elevation-2",
    class: { "no-show-permission": !_vm.userHasPermissionTo("show") },
    attrs: {
      headers: _vm.headers,
      items: _vm.tasks,
      page: _vm.pagination.page,
      "items-per-page": _vm.paginationTaskList.rowsPerPage,
      loading: _vm.loading,
      "loading-text": "",
      "items-per-page-text": _vm.rowsPerPageText,
      "items-per-page-items": _vm.rowsPerPageItems,
      "header-props": { sortIcon: _vm.sortIcon },
      "footer-props": {
        prevIcon: _vm.prevIcon,
        nextIcon: _vm.nextIcon,
        "items-per-page-options": _vm.rowsPerPageItems
      }
    },
    on: {
      "update:page": function($event) {
        return _vm.$set(_vm.pagination, "page", $event)
      },
      "update:itemsPerPage": function($event) {
        return _vm.$set(_vm.paginationTaskList, "rowsPerPage", $event)
      },
      "update:items-per-page": function($event) {
        return _vm.$set(_vm.paginationTaskList, "rowsPerPage", $event)
      },
      pagination: function($event) {
        return _vm.setRowsOnLocalStorage(
          _vm.dataTableTaskListId,
          _vm.paginationTaskList.rowsPerPage
        )
      }
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(props) {
          return [
            _c(
              "tr",
              {
                class: { "cursor-pointer": _vm.userHasPermissionTo("show") },
                on: {
                  click: function($event) {
                    return _vm.$emit("viewTask", props.item)
                  }
                }
              },
              [
                _c(
                  "td",
                  [
                    _c("activity-task-status-icon", {
                      attrs: {
                        status: props.item.state,
                        delayed: _vm.isDelayed(props.item)
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.title))]),
                _vm._v(" "),
                _c("td", [
                  _c("span", [
                    _vm._v(_vm._s(_vm.getUserName(props.item.user_assignee_id)))
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.getFormattedDate(props.item.scheduled_date))
                    )
                  ])
                ])
              ]
            )
          ]
        }
      },
      {
        key: "pageText",
        fn: function(props) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(props.pageStart) +
                " - " +
                _vm._s(props.pageStop) +
                " " +
                _vm._s(_vm.$t("tables.Of")) +
                "\n    " +
                _vm._s(props.itemsLength) +
                "\n  "
            )
          ]
        }
      },
      {
        key: "no-data",
        fn: function() {
          return [_vm.loading ? _c("div") : _vm._e()]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51cb1639", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51cb1639","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Activities/TasksListTable.vue
// module id = null
// module chunks = 